<template>
  <BlockFieldset class="project-financing">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('durationYears')"
          label-for="durationYears"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="durationYears"
            v-model="project.investmentDeductionAllowance.durationYears"
            :disabled="isBlockReadOnly"
            unit="unit_years"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('interestRatePercent')"
          label-for="interestRatePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="interestRatePercent"
            v-model="project.investmentDeductionAllowance.interestRatePercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('fixedRateYears')"
          label-for="fixedRateYears"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="fixedRateYears"
            v-model="project.investmentDeductionAllowance.fixedRateYears"
            :disabled="isBlockReadOnly"
            unit="unit_years"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('repaymentRatePercent')"
          label-for="repaymentRatePercent"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <UnitInputNumber
            id="repaymentRatePercent"
            v-model="project.investmentDeductionAllowance.repaymentRatePercent"
            :disabled="isBlockReadOnly"
            unit="unit_percent"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="hasSaveButton" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('project_financing') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import UnitInputNumber from '@/components/UnitInputNumber';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectFinancingInput } from './projectFinancingInput';

/** Number of the unsaved project (ProjectEdit `_new`): its values go with `createProject`. */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-financing ("Finanzierung", plan docs/work/_done/2026-10-project-block-financing): the
 * financing fields of `investmentDeductionAllowance`, saved through its own mutation with its own
 * button. On the unsaved project it has no save button. Emits `dirty` and `saved`.
 */
export default {
  name: 'ProjectFinancing',
  components: {
    BlockFieldset,
    UnitInputNumber,
  },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    blockInput() {
      return toProjectFinancingInput(this.project);
    },
    hasSaveButton() {
      return !this.isBlockReadOnly && this.project.number !== NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectFinancing']),
    saveBlockInput(input) {
      return this.updateProjectFinancing({ projectNumber: this.project.number, input });
    },
  },
};
</script>
